import React, { useEffect, useState } from 'react';
import { IconButton, Box, CardMedia, Typography, Hidden } from '@mui/material';
import { Button } from 'tt-ui-lib/core';
import { LeftIcon, ShareIcon } from 'tt-ui-lib/icons';
import { Link, useParams } from 'react-router-dom';
import { useNavigate } from 'react-router';
import { useLazyQuery } from '@apollo/client';
import styles from './TutorialPage.module.scss';
import { GET_TUTORIAL_BY_ID } from '../../../api';
import PartialLoader from '../../../components/layout/PartialLoader';
import { ShareModal } from '../../../modules/tt-modals';
import TitledBackgroundHeader from '../../../components/layout/TitledBackgroundHeader';

const TutorialPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [tutorial, setTutorial] = useState({});
  const [loading, setLoading] = useState(true);
  const [playVideo, setPlayVideo] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [getTutorialById] = useLazyQuery(GET_TUTORIAL_BY_ID, {
    variables: { id: id },
    fetchPolicy: 'network-only',
  });

  const getTutorial = async () => {
    const response = await getTutorialById();
    if (response.data && response.data.showTutorialById) {
      if (response.data.showTutorialById.type === 'pdf') {
        window.location.href = response.data.showTutorialById.file;
        return;
      }
      setTutorial(response.data.showTutorialById);
    } else {
      navigate('/tutorials');
    }
    setLoading(false);
  };

  const openPdf = () => {
    if (tutorial.type === 'pdf') {
      window.open(tutorial.file, '_blank');
    }
  };

  useEffect(() => {
    getTutorial();
  }, []);

  return (
    <Box className={styles.pageContainer}>
      <PartialLoader loading={loading} isLightContainer />
      <TitledBackgroundHeader isHeaderNav title="Tutorials" />
      <Box className={styles.content}>
        <Box className={styles.contentHeader}>
          <Box className={styles.contentTitleBlock}>
            <Box className={styles.backIcon}>
              <Link to="/tutorials">
                <LeftIcon style={{ width: 24, height: 24 }} />
              </Link>

              <Hidden smDown>
                <Box onClick={openPdf} className={styles.backIcon}>
                  <Typography className={styles.contentTitle}>{tutorial.name}</Typography>
                  {tutorial.type === 'pdf' && (
                    <img
                      src="/images/tutorials/pdf-file.png"
                      alt=""
                      style={{ width: 24, height: 24 }}
                    />
                  )}
                </Box>
              </Hidden>
            </Box>
            <Button
              type="mainButton"
              className={styles.shareButton}
              onClick={() => setShowShareModal(true)}
            >
              <ShareIcon style={{ width: 24, height: 24 }} />
              <Typography className={styles.shareText}>share</Typography>
            </Button>
          </Box>
          <Hidden smUp>
            <Box onClick={openPdf} className={styles.backIcon}>
              <Typography className={styles.contentTitle}>{tutorial.name}</Typography>
              {tutorial.type === 'pdf' && (
                <img
                  src="/images/tutorials/pdf-file.png"
                  alt=""
                  style={{ width: 24, height: 24 }}
                />
              )}
            </Box>
          </Hidden>
        </Box>
        <Box>
          {playVideo ? (
            <CardMedia
              sx={{ width: '100%', maxHeight: 690 }}
              component="video"
              src={tutorial.file}
              controls
              autoPlay
            />
          ) : (
            <Box className={styles.video}>
              <img
                className={styles.videoBackgroundImage}
                src={tutorial.preview}
                alt=""
                style={{ width: '100%', height: '100%' }}
              />
              {tutorial.type === 'video' && (
                <Box className={styles.videoIconBlock}>
                  <IconButton
                    type="button"
                    style={{ backgroundColor: 'rgba(0, 0, 0, 0.04)' }}
                    onClick={() => setPlayVideo(true)}
                  >
                    <img
                      src="/images/tutorials/video-play-icon.svg"
                      alt=""
                      style={{ width: 24, height: 24 }}
                    />
                  </IconButton>
                </Box>
              )}
            </Box>
          )}
        </Box>
        {tutorial.description && (
          <Box className={styles.textBlock}>
            <Typography className={styles.title}>Description</Typography>
            <Typography className={styles.description}>{tutorial.description}</Typography>
          </Box>
        )}
      </Box>
      <ShareModal open={showShareModal} closeModal={() => setShowShareModal(false)} />
    </Box>
  );
};

export default TutorialPage;
